import { createStructuredSelector } from '@opengov/compose-app/reselect';

import { storiesMsgs } from '../locale';

import { IMaintenanceProps } from './Maintenance';

export const selectMaintenanceProps = createStructuredSelector<any, IMaintenanceProps>({
  messages: storiesMsgs
});
